import React, { Suspense, useState, useEffect } from "react";
import "./RenterList.css";
import "bootstrap/dist/css/bootstrap.min.css";
import {  useHistory } from "react-router-dom";
import ReactSelect from "react-select";
import makeAnimated from "react-select/animated";
import {
  Form,
  Col,
  FormGroup,
  Row,
  Label,
  Input,
  CardText,
} from "reactstrap";
import Loading from "../../components/Loading";
import Button from "@mui/material/Button";
import { FaCalendarAlt } from "react-icons/fa";
import DatePicker from "react-datepicker";
import {
  isFutureDate,isValidDateRange
  } from "../../Helpers/Validation";
import Footer from "../../DefaultLayout/Footer";
import DashboardNavbar from "../../DefaultLayout/DashboardNavbar.js";
import LoggedHeader from "../../DefaultLayout/LoggedHeader";
import { addTenantList, getTenantList } from "../../actions/propertyAction";
import { toast } from "react-toastify";
import { connect} from "react-redux";
import { 
  CircularProgress,
} from "@mui/material"; 
import Nodes from "../../Helpers/nodesList.js";
import moment from "moment";
import CheckboxTree from "react-checkbox-tree";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdChevronRight,
  MdKeyboardArrowDown,
  MdAddBox,
  MdIndeterminateCheckBox,
  MdAdd,
  MdRemove,
} from "react-icons/md";
import PerfectScrollbar from "react-perfect-scrollbar";
import { getContentDetails } from "../../actions/cmsAction";


const colourStyles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isFocused ? "#999999" : null,
      color: "#333333",
      border: "1px solid #b4b4b4",
    };
  },
};

const icons = {
  check: (
    <MdCheckBox
      className="rct-icon rct-icon-check"
      sx={{ color: "#000!important" }}
    />
  ),
  uncheck: <MdCheckBoxOutlineBlank className="rct-icon rct-icon-uncheck" />,
  halfCheck: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-half-check" />
  ),
  expandClose: <MdChevronRight className="rct-icon rct-icon-expand-close" />,
  expandOpen: <MdKeyboardArrowDown className="rct-icon rct-icon-expand-open" />,
  expandAll: <MdAddBox className="rct-icon rct-icon-expand-all" />,
  collapseAll: (
    <MdIndeterminateCheckBox className="rct-icon rct-icon-collapse-all" />
  ),
  parentClose: <MdAdd className="rct-icon rct-icon-parent-close" />,
  parentOpen: <MdRemove className="rct-icon rct-icon-parent-open" />,
  // leaf: <MdInsertDriveFile className="rct-icon rct-icon-leaf-close" />
};


const Renters_list = (props) => {
  const history = useHistory();
    const nodes = Nodes(); 
  const animatedComponents = makeAnimated();
  // const currentLanguageCode = localStorage.getItem("prevLangFront") 
  const { frontLabelsName } = props.label;
  const [budget, setBudget] = useState("");
  const [depositType, setDepositType] = useState("");
  const [depositAmount, setDepositAmount] = useState("");
  const [familySize, setFamilySize] = useState("");
  const [child, setChild] = useState("");
  const [workPerson, setWorkPerson] = useState("");
  const [typeOfWork, setTypeOfWork] = useState("");
  const [spouseOfWork, setSpouseOfWork] = useState("");
  const [attachmentType, setAttachmentType] = useState("");
   const [checkedTree, setCheckedTree] = useState(["0"]);
    const [expandedTree, setExpandedTree] = useState(["0"]);
 
    const [clickedTree, setClickedTree] = useState([]);
    const [openZip, setOpenZip] = useState(false);
  const [attachments, setAttachments] = useState("");
  const [imagePreview, setPreview] = useState([]);
  const [imagePreviewUrl, setUrl] = useState([]);

  const[disableSubmitButton,setDisableSubmitButton]=useState(false)

 
 const[daysDelivery,setDaysDelivery]= useState(null);
    const[years,setYears]= useState("");
  const[availableInsurance,setAvailableInsurance]= useState("");
  const [propertyType, setPropertyType] = useState(null);
  const [bhk, setBhk] = useState(null);
  const [area, setArea] = useState("");
  const[pets,setPets]= useState("");
  const[size,setSize]= useState("");
  const[queries,setQueries]= useState("");
  const [availableFrom, setAvailableFrom] = useState(new Date());
  const [availableTo, setAvailableTo] = useState(new Date());
  const [shortTerm, setShortTerm] = useState(false);
  const [longTerm, setLongTerm] = useState(false);
  const[toDateError,setToDateError]= useState("");
  const[fromDateError,setFromDateError]= useState("");
    const [response, setResponse] = useState("")


 
     
    
        
          //  useEffect(() => {
          //    props.getContentDetails('tenant-registry', currentLanguageCode).then((res) => {
          
          //       });
          
              
          //   }, [currentLanguageCode]);

            function isValidDateString(dateStr) {
 if (typeof dateStr !== 'string') return false;
  const date = new Date(dateStr);
  return !isNaN(date.getTime());
}
  


  useEffect(() => {
    props.getTenantList().then((res) => {
      res?.budget && res?.budget !== "undefined"
        ? setBudget(res?.budget)
        : setBudget("");
        setResponse(res?.registered ? res?.registered: "")
        res?.availabilityType == 2 && setLongTerm(true);
      res?.availabilityType == 1 && setShortTerm(true)
       
      if (res?.availabilityType === "") {
        setLongTerm(false);
        setShortTerm(false);
      }
          if (res?.availabilityTo !== null) {
                setAvailableTo(moment(res?.availabilityTo).toDate());
              }
              if (res?.availabilityFrom !== null) {
                setAvailableFrom(moment(res?.availabilityFrom).toDate());
              }
        setQueries(res?.queries_comment ? res?.queries_comment :"")
        setSize(res?.minimum_size_required ? res?.minimum_size_required :"")
        setPets(res?.pets?String(res?.pets) :"")
        setArea(res?.area_required ? res?.area_required.toString():"" )
        res?.area_required ? setCheckedTree(res?.area_required) : setCheckedTree(["0"]);
        let b = bhkOptions.filter((e) => res?.rooms?.includes(e.value));
        setBhk(b)
        let a = options.filter((e) => res?.apartmentType?.includes(e.value));
        setPropertyType(a)
        setAvailableInsurance(res?.available_insurance ? res?.available_insurance :"")

      let selectedDeposits = depositOptions.filter((e) => res?.depositType?.includes(e.value));
   selectedDeposits?
         setDepositType(selectedDeposits)
        : setDepositType("");
      res?.depositAmount && res?.depositAmount !== "undefined"
        ? setDepositAmount(res?.depositAmount)
        : setDepositAmount("");

        res?.totalYears && res?.totalYears !== "undefined"
        ? setYears(res?.totalYears)
        : setYears("");
        
        res?.dayDelivery &&isValidDateString(res?.dayDelivery)  
        ? setDaysDelivery(moment(res?.dayDelivery).toDate())
        : setDaysDelivery(null);

        
      res?.familySize  ? setFamilySize(res?.familySize)
        : setFamilySize("");
      res?.child && res?.child !== "undefined"
        ? setChild(res?.child)
        : setChild("");
      res?.workPerson && res?.workPerson !== "undefined"
        ? setWorkPerson(res?.workPerson)
        : setWorkPerson("");
      res?.typeOfWork && res?.typeOfWork !== "undefined"
        ? setTypeOfWork(res?.typeOfWork)
        : setTypeOfWork("");
      res?.spouseOfWork && res?.spouseOfWork !== "undefined"
        ? setSpouseOfWork(res?.spouseOfWork)
        : setSpouseOfWork("");
      res?.attachmentType && res?.attachmentType !== "undefined"
        ? setAttachmentType(res?.attachmentType)
        : setAttachmentType("");
      setAttachments(res?.attachments);

      setPreview(res?.attachments);
      setUrl(res?.attachments);

   

 
 

  

  

    
    });
  }, [getTenantList]);

  const handleZipCode = () => {
    setOpenZip(!openZip);
  
  };

      const depositOptions=[
    {
label: frontLabelsName
  ? frontLabelsName.filter(
      (e) => e.key == "lbl_renters_insurance"
    ).length > 0
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_renters_insurance"
      )[0]["value"] || "lbl_renters_insurance"
    : "lbl_renters_insurance"
  : "lbl_renters_insurance",
  value:"renters_insurance"
  },
  {
    label:frontLabelsName
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_security_deposit"
      ).length > 0
      ? frontLabelsName.filter(
          (e) => e.key == "lbl_security_deposit"
        )[0]["value"] || "lbl_security_deposit"
      : "lbl_security_deposit"
    : "lbl_security_deposit",
    value:"security_deposit"
  },
  {
label:frontLabelsName
? frontLabelsName.filter(
    (e) => e.key == "lbl_bank_guarantee"
  ).length > 0
  ? frontLabelsName.filter(
      (e) => e.key == "lbl_bank_guarantee"
    )[0]["value"] || "lbl_bank_guarantee"
  : "lbl_bank_guarantee"
: "lbl_bank_guarantee",
value:"bank_guarantee"
  },
  {
    label:frontLabelsName
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_collateral"
      ).length > 0
      ? frontLabelsName.filter(
          (e) => e.key == "lbl_collateral"
        )[0]["value"] || "lbl_collateral"
      : "lbl_collateral"
    : "lbl_collateral",
    value:"collateral"
  },
  {
    label:frontLabelsName
    ? frontLabelsName.filter(
        (e) => e.key == "lbl_other"
      ).length > 0
      ? frontLabelsName.filter(
          (e) => e.key == "lbl_other"
        )[0]["value"] || "lbl_other"
      : "lbl_other"
    : "lbl_other",
      value:"other"
  },



]

 const handleDepositChange=(selectedOption)=>{
    setDepositType(selectedOption)
  }


  function priceFormat(x) {
    const data = x?.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ".");
    return data;
  }
  let PriceArray = [];
  for (let i = 1; i <= 1500; i++) {
    PriceArray.push(priceFormat(1000 * [i]));
  }

  let daysArray=[]
  for (let i = 1; i <= 365; i++) {
    daysArray.push(i);
  }

  
  let YearsArray = [];
  for (let i = 2; i <= 25; i++) {
    YearsArray.push(`${i} ${frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_years").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_years")[0][
              "value"
            ] || "lbl_years"
          : "lbl_years"
        : "lbl_years"}` );
  }

    let monthsArray = [];
  for (let i = 1; i <= 12; i++) {
    monthsArray.push(`${i} ${frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_months").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_months")[0][
              "value"
            ] || "lbl_months"
          : "lbl_months"
        : "lbl_months"}`  );
  }
  const handleAddTenantList = () => {
        let from_err=""
        let to_err=""
    if(longTerm===true || shortTerm === true ){
      from_err = isFutureDate(
        availableFrom,
        "lbl_available_from"
      );
    }
        
            if (shortTerm) {
              to_err = isFutureDate(availableTo, "lbl_available_to");
            }
    
            if(shortTerm && availableTo&& availableFrom){
              let check= isValidDateRange(availableFrom,availableTo)
           
              if(!check){
                to_err = "lbl_available_to_date_should_not_be_before_available_date";
              }else{
                to_err =""
              }
            }
    
            if(from_err || to_err ){
        
              setFromDateError(frontLabelsName
                ? frontLabelsName.filter((e) => e.key == from_err).length > 0
                  ? frontLabelsName.filter((e) => e.key == from_err)[0][
                      "value"
                    ] || from_err
                  : from_err
                : from_err)
              setToDateError(frontLabelsName
                ? frontLabelsName.filter((e) => e.key == to_err).length > 0
                  ? frontLabelsName.filter((e) => e.key == to_err)[0]["value"] ||
                  to_err
                  : to_err
                : to_err)
            }else{
        
              setFromDateError("")
              setToDateError("")
    setDisableSubmitButton(true)
    let temptypeArray = [];

    propertyType?.map((a) => temptypeArray.push(a.value));
       let tempDepositType =[]
    depositType.map((a) => tempDepositType.push(a.value))
    let temptBhkArray = [];
    bhk.map((a) => temptBhkArray.push(a.value));
    const formData = new FormData();

    formData.append("budget", budget);
    if( tempDepositType.length>0){
      for (let i = 0; i < tempDepositType.length; i++) {
        formData.append("depositType", tempDepositType[i]);
      }}else{
        formData.append("depositType", "");
      }
    formData.append("depositAmount", depositAmount);
    formData.append("familySize", familySize);
    formData.append("child", child);
    formData.append("workPerson", workPerson);
    formData.append("typeOfWork", typeOfWork);
    formData.append("spouseOfWork", spouseOfWork);
    formData.append("dayDelivery", daysDelivery);
      formData.append("totalYears", years);

    formData.append("available_insurance", Number(availableInsurance) );
    formData.append("pets",pets);
    formData.append("queries_comment", queries);
    formData.append("registered",Number(response) );
    formData.append("minimum_size_required", Number(size));
    if( checkedTree.length>0){
      for (let i = 0; i < checkedTree.length; i++) {
        formData.append("area_required", checkedTree[i]);
      }}else{
        formData.append("area_required", "");
      }


    if( temptypeArray.length>0){
    for (let i = 0; i < temptypeArray.length; i++) {
    formData.append("apartmentType", temptypeArray[i]);
    }}else{
      formData.append("apartmentType", "");
    }
    if(temptBhkArray.length>0){
    for (let i = 0; i < temptBhkArray.length; i++) {
    formData.append("rooms", temptBhkArray[i]);
    }}else{
      formData.append("rooms", ""); 
    }
    formData.append("availabilityType",  longTerm === true ? 2: shortTerm === true ? 1 : "");
    formData.append("availabilityTo", longTerm === true ? "" : availableTo);
    formData.append("availabilityFrom", availableFrom);


 

    formData.append("attachmentType", attachmentType);
    for (let i = 0; i < imagePreviewUrl?.length; i++) {
      formData.append("attachments", imagePreviewUrl[i]);
    }



    props
      .addTenantList(formData)
      .then((res) => {
        setDisableSubmitButton(false)
        toast.success(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == res.data.message).length > 0
              ? frontLabelsName.filter((e) => e.key == res.data.message)[0][
                  "value"
                ] || res.data.message
              : res.data.message
            : res.data.message
        );
      
        history.push("/dashboard");
      })
      .catch((err) => {
        setDisableSubmitButton(false)
        toast.error(
          frontLabelsName
            ? frontLabelsName.filter((e) => e.key == err.response.data.message)
                .length > 0
              ? frontLabelsName.filter((e) => e.key == err.response.data.message)[0][
                  "value"
                ] || err.response.data.message
              : err.response.data.message
            : err.response.data.message
        );
      });
    }
  };



  const handleChange = (selectedOption) => {
    setPropertyType(selectedOption);
  };

  const options = [
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_detached_house").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_detached_house")[0][
              "value"
            ] || "lbl_detached_house"
          : "lbl_detached_house"
        : "lbl_detached_house",
      value: "detachedHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_duplex").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_duplex")[0]["value"] ||
            "lbl_duplex"
          : "lbl_duplex"
        : "lbl_duplex",
      value: "duplex",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_triple_apt_house")[0][
              "value"
            ] || "lbl_triple_apt_house"
          : "lbl_triple_apt_house"
        : "lbl_triple_apt_house",
      value: "tripleAptHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_apt_building").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_apt_building")[0][
              "value"
            ] || "lbl_apt_building"
          : "lbl_apt_building"
        : "lbl_apt_building",
      value: "aptBulding",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin").length >
          0
          ? frontLabelsName.filter((e) => e.key == "lbl_townhouse_twin")[0][
              "value"
            ] || "lbl_townhouse_twin"
          : "lbl_townhouse_twin"
        : "lbl_townhouse_twin",
      value: "townhouseTwin",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_garage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_garage")[0]["value"] ||
            "lbl_garage"
          : "lbl_garage"
        : "lbl_garage",
      value: "garage",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_summer_house").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_summer_house")[0][
              "value"
            ] || "lbl_summer_house"
          : "lbl_summer_house"
        : "lbl_summer_house",
      value: "summerHouse",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_co_tenant")[0][
              "value"
            ] || "lbl_co_tenant"
          : "lbl_co_tenant"
        : "lbl_co_tenant",
      value: "cotenant",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")
            .length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_hotel_guest_house")[0][
              "value"
            ] || "lbl_hotel_guest_house"
          : "lbl_hotel_guest_house"
        : "lbl_hotel_guest_house",
      value: "hotelGesthouse",
    },
  ];

  const bhkOptions = [
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_storage").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_storage")[0]["value"] ||
            "lbl_storage"
          : "lbl_storage"
        : "lbl_storage",
      value: "Storage",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_single_room").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_single_room")[0][
              "value"
            ] || "lbl_single_room"
          : "lbl_single_room"
        : "lbl_single_room",
      value: "Single Room",
    },
    {
      label: frontLabelsName
        ? frontLabelsName.filter((e) => e.key == "lbl_studio").length > 0
          ? frontLabelsName.filter((e) => e.key == "lbl_studio")[0]["value"] ||
            "lbl_studio"
          : "lbl_studio"
        : "lbl_studio",
      value: "Studio",
    },
    { label: "2", value: "2" },
    { label: "3", value: "3" },
    { label: "4", value: "4" },
    { label: "5", value: "5" },
    { label: "6", value: "6" },
    { label: "7", value: "7" },
    { label: "8", value: "8" },
    { label: "9+", value: "9+" },
  ];

  var zipcustom;
  if (checkedTree && checkedTree[0] == "0") {
    zipcustom = "";
  } else if (checkedTree && checkedTree[0] != "0") {
    zipcustom = checkedTree?.toString();
  }

  const handleBhkChange = (selectedOption) => {
    setBhk(selectedOption);
  };

    useEffect(() => {
      window.scrollTo({ top: 0 });
    },[])
 

  return (
    <React.Fragment>
      <Suspense fallback={<Loading />}>
        <LoggedHeader />

        <DashboardNavbar/>
      </Suspense>
      <div className="container mb-0 pt-0">
        <div className=" renter-list12">
          <div className="">
            <div className="row">
             
              <div className="col-lg-12 col-md-12 custom-flex-made-basic-info trams-condition-box">
                 <div>
                 <strong className="set-black set-yellow mb-2">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_what_is_the_tenant_register")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_what_is_the_tenant_register"
                              )[0]["value"] || "lbl_what_is_the_tenant_register"
                            : "lbl_what_is_the_tenant_register"
                          : "lbl_what_is_the_tenant_register"}
                      </strong>
                      <CardText className="pt-2 renters-card-subtext cursor-style mb-0">
                               {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_what_is_the_tenant_register_discription_1"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_what_is_the_tenant_register_discription_1"
                                    )[0]["value"] || "lbl_what_is_the_tenant_register_discription_1"
                                  : "lbl_what_is_the_tenant_register_discription_1"
                                : "lbl_what_is_the_tenant_register_discription_1"}
                             </CardText>
                             <CardText className="pt-2 renters-card-subtext cursor-style mb-0">
                               {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_what_is_the_tenant_register_discription_2"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_what_is_the_tenant_register_discription_2"
                                    )[0]["value"] || "lbl_what_is_the_tenant_register_discription_2"
                                  : "lbl_what_is_the_tenant_register_discription_2"
                                : "lbl_what_is_the_tenant_register_discription_2"}
                             </CardText>
                              <CardText className="pt-2 renters-card-subtext cursor-style mb-0">
                               {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_what_is_the_tenant_register_discription_3"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_what_is_the_tenant_register_discription_3"
                                    )[0]["value"] || "lbl_what_is_the_tenant_register_discription_3"
                                  : "lbl_what_is_the_tenant_register_discription_3"
                                : "lbl_what_is_the_tenant_register_discription_3"}
                             </CardText>
                              <CardText className="pt-2 renters-card-subtext cursor-style mb-4">
                               {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_what_is_the_tenant_register_discription_4"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_what_is_the_tenant_register_discription_4"
                                    )[0]["value"] || "lbl_what_is_the_tenant_register_discription_4"
                                  : "lbl_what_is_the_tenant_register_discription_4"
                                : "lbl_what_is_the_tenant_register_discription_4"}
                             </CardText>
              </div>
                <Form className="st-fl-hg-trem-basic">
                  <div className="set-pdd-basic-info ps-0">
                    <div className="text-center">
                      <h2 className="custom-h2-size1 mb-2">
                        {frontLabelsName
                          ? frontLabelsName.filter((e) => e.key == "lbl_tenant_profile")
                              .length > 0
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_tenant_profile"
                              )[0]["value"] || "lbl_tenant_profile"
                            : "lbl_tenant_profile"
                          : "lbl_tenant_profile"}
                      </h2>
                    </div>
                  
                    <div className="row d-flex pt-2">
                      <div className="col-12 col-lg-6">
                          <div className="d-flex ">
                      <strong className="set-black set-yellow mb-2">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_family_information"
                                  ).length > 0
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_family_information"
                                    )[0]["value"] || "lbl_family_information"
                                  : "lbl_family_information"
                                : "lbl_family_information"}
                            </strong>
                             
                           </div>
                            <FormGroup className="pt-1 set">
                              <Row className="renter-row-style">
                              <Col lg="12" className="renter-input-width1 d-flex align-items-center ">
                              <Label className="renter-info-label margin-negative  width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_size_of_family"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_size_of_family"
                                      )[0]["value"] || "lbl_size_of_family"
                                    : "lbl_size_of_family"
                                  : "lbl_size_of_family"}
                              </Label>
                              <select
                                className={`select_style set-bg-feild ${!familySize ? "has-placeholder" : ""}`}
                                id="inputGroupSelect02"
                                value={familySize}
                                onChange={(e) => setFamilySize(e.target.value)}
                               
                                
                              >
                                <option value="" disabled  >
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_size_of_family"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_size_of_family"
                                        )[0]["value"] || "lbl_size_of_family"
                                      : "lbl_size_of_family"
                                    : "lbl_size_of_family"}
                                </option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6+</option>
                              </select>
                            </Col>
                            <Col lg="12" className="renter-input-width2 d-flex align-items-center">
                              <Label className="renter-info-label margin-negative width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_no_children"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_no_children"
                                      )[0]["value"] || "lbl_no_children"
                                    : "lbl_no_children"
                                  : "lbl_no_children"}
                              </Label>
                              <select
                                     className={`select_style set-bg-feild ${!child ? "has-placeholder" : ""}`}
                                id="inputGroupSelect02"
                                value={child}
                                onChange={(e) => setChild(e.target.value)}
                              >
                                <option value="" disabled>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_no_children"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_no_children"
                                        )[0]["value"] || "lbl_no_children"
                                      : "lbl_no_children"
                                    : "lbl_no_children"}
                                </option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6+</option>
                              </select>
                            </Col>
                            <Col lg="12" className="renter-input-width3 d-flex align-items-center">
                              <Label className="renter-info-label margin-negative width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_no_of_person_work"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_no_of_person_work"
                                      )[0]["value"] || "lbl_no_of_person_work"
                                    : "lbl_no_of_person_work"
                                  : "lbl_no_of_person_work"}
                              </Label>
                              <select
                                  className={`select_style set-bg-feild ${!workPerson ? "has-placeholder" : ""}`}
                                id="inputGroupSelect02"
                                value={workPerson}
                                onChange={(e) => setWorkPerson(e.target.value)}
                              >
                                <option value="" disabled>
                                  {frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_no_of_person_work"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) =>
                                            e.key == "lbl_no_of_person_work"
                                        )[0]["value"] || "lbl_no_of_person_work"
                                      : "lbl_no_of_person_work"
                                    : "lbl_no_of_person_work"}
                                </option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6+</option>
                              </select>
                            </Col>
                            <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                              <Label className="renter-info-label margin-negative width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_rent_budget"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_rent_budget"
                                      )[0]["value"] || "lbl_rent_budget"
                                    : "lbl_rent_budget"
                                  : "lbl_rent_budget"}
                              </Label>
                              
                                           
                                           <select
                                              className={`select_style set-bg-feild ${!budget ? "has-placeholder" : ""}`}
                                             id="inputGroupSelect02"
                                             value={budget}
                                             onChange={(e) => setBudget(e.target.value)}
                                           >
                                             <option value="" disabled>
                                               {  frontLabelsName
                                                 ? frontLabelsName.filter(
                                                     (e) => e.key == "lbl_rent_budget"
                                                   ).length > 0
                                                   ? frontLabelsName.filter(
                                                       (e) => e.key == "lbl_rent_budget"
                                                     )[0]["value"] || "lbl_rent_budget"
                                                   : "lbl_rent_budget"
                                                 : "lbl_rent_budget"}
                                             </option>
                                             {PriceArray &&
                               PriceArray.length > 0 &&
                               PriceArray.map((data, i) => (
                                 <option value={data} key={i}>
                                   {data}
                                 </option>
                               ))}
                                           </select>
                             
                                         
                             
                              
                             
                            </Col>
                          
                            <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                              <Label className="renter-info-label width-class lineheight-class margin-negative fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_available_insurances"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_available_insurances"
                                      )[0]["value"] || "lbl_available_insurances"
                                    : "lbl_available_insurances"
                                  : "lbl_available_insurances"}
                              </Label>
                                    <div className="width-100-percent" >
                             <ReactSelect
                                                                   defaultValue={depositType}
                                                                   styles={colourStyles}
                                                                   components={animatedComponents}
                                                                   placeholder=    {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_available_insurances"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_available_insurances"
                                      )[0]["value"] || "lbl_available_insurances"
                                    : "lbl_available_insurances"
                                  : "lbl_available_insurances"}
                                                                   name="depositType"
                                                                   options={depositOptions}
                                                                   onChange={handleDepositChange}
                                                                   value={depositType}
                                                                   isClearable
                                                                   isMulti
                                                                
                                                                 />
                                                                 </div>
                            </Col>
                              <Col lg="12" className="d-flex align-items-center">
                              <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_man_type_work"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_man_type_work"
                                      )[0]["value"] || "lbl_man_type_work"
                                    : "lbl_man_type_work"
                                  : "lbl_man_type_work"}
                              </Label>
                              <Input
                                type="text"
                                name="Man type of work"
                                placeholder={
                                  frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_man_type_work"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_man_type_work"
                                        )[0]["value"] || "lbl_man_type_work"
                                      : "lbl_man_type_work"
                                    : "lbl_man_type_work"
                                }
                                className="input_style padding-inline-end"
                                value={typeOfWork}
                                onChange={(e) => setTypeOfWork(e.target.value)}
                              />
                            </Col>
                            <Col lg="12" className="d-flex align-items-center">
                              <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_women_type_work"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_women_type_work"
                                      )[0]["value"] || "lbl_women_type_work"
                                    : "lbl_women_type_work"
                                  : "lbl_women_type_work"}
                              </Label>
                              <Input
                                type="text"
                                placeholder={
                                  frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_women_type_work"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_women_type_work"
                                        )[0]["value"] || "lbl_women_type_work"
                                      : "lbl_women_type_work"
                                    : "lbl_women_type_work"
                                }
                                className="input_style padding-inline-end"
                                value={spouseOfWork}
                                onChange={(e) =>
                                  setSpouseOfWork(e.target.value)
                                }
                              />
                            </Col>
                              </Row>
                            </FormGroup>
                      </div>
                      <div className="col-12 col-lg-6">
                      <div className="d-flex justify-content-start">
                      <strong className="set-black set-yellow mb-2">
                       {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_housing_need"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_housing_need"
                          )[0]["value"] || "lbl_housing_need"
                        : "lbl_housing_need"
                      : "lbl_housing_need"}
                        </strong>
                        </div>
                        <FormGroup className="pt-1 set">
                          <Row className="renter-row-style">
                       
                          
                           <Col lg="12" className="renter-input-width1 width-100class d-flex align-items-center">
                              <Label className="renter-info-label width-class lineheight-class margin-negative fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_apartment_type"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_apartment_type"
                                      )[0]["value"] || "lbl_apartment_type"
                                    : "lbl_apartment_type"
                                  : "lbl_apartment_type"}
                              </Label>
                              <ReactSelect                         
                          styles={colourStyles}
                          components={animatedComponents}
                          placeholder=   {frontLabelsName
                            ? frontLabelsName.filter(
                                (e) => e.key == "lbl_apartment_type"
                              ).length > 0
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_apartment_type"
                                )[0]["value"] || "lbl_apartment_type"
                              : "lbl_apartment_type"
                            : "lbl_apartment_type"}
                          name="property type"
                          options={options}
                          onChange={handleChange}
                          value={propertyType}
                          isClearable
                          isMulti
                        />
                            </Col>
                            <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                              <Label className="renter-info-label width-class lineheight-class margin-negative fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_area"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_area"
                                      )[0]["value"] || "lbl_area"
                                    : "lbl_area"
                                  : "lbl_area"} 
                              </Label>
                              <div className="width-100-percent" >
                              <Input
                                type="text"
                                placeholder={
                                 frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_area"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_area"
                                        )[0]["value"] || "lbl_area"
                                      : "lbl_area"
                                    : "lbl_area"
                                }
                                className="input_style "
                                value={zipcustom}
                                onClick={handleZipCode}
                              />
                                                        {openZip && (
                                                        <div className="zipcode-style">
                                                          <PerfectScrollbar
                                                            style={{
                                                              maxHeight: "300px",
                                                              overflowX: "hidden",
                              
                                                              width: "100%",
                                                            }}
                                                          >
                                                            <CheckboxTree
                                                              nodes={nodes}
                                                              checked={checkedTree}
                                                              expanded={expandedTree}
                                                              expandOnClick={true}
                                                              onClick={(clickedTree) =>
                                                                setClickedTree(clickedTree)
                                                              }
                                                              onCheck={(checkedTree) => {
                                                                setCheckedTree(checkedTree);
                                                              }}
                                                              onExpand={(expandedTree) =>
                                                                setExpandedTree(expandedTree)
                                                              }
                                                              icons={icons}
                                                              // nativeCheckboxes={true}
                                                            />
                                                          </PerfectScrollbar>
                                                        </div>
                                                      )}
                                                      </div>
                            </Col>
                            <Col lg="12" className="renter-input-width1 width-100class d-flex align-items-center">
                              <Label className="renter-info-label width-class lineheight-class margin-negative fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_rooms"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_rooms"
                                      )[0]["value"] || "lbl_rooms"
                                    : "lbl_rooms"
                                  : "lbl_rooms"}
                              </Label>
                              <ReactSelect
                          defaultValue={bhk}
                          styles={colourStyles}
                          components={animatedComponents}
                          placeholder={
                            frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_select_bhk"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_select_bhk"
                                  )[0]["value"] || "lbl_select_bhk"
                                : "lbl_select_bhk"
                              : "lbl_select_bhk"
                          }
                          name="bhk"
                          options={bhkOptions}
                          onChange={handleBhkChange}
                          value={bhk}
                          isClearable
                          isMulti
                     
                        />
                            </Col>
                            <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                              <Label className="renter-info-label width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_pets"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_pets"
                                      )[0]["value"] || "lbl_pets"
                                    : "lbl_pets"
                                  : "lbl_pets"}
                              </Label>
                          
                              <div className="width-100 d-flex align-items-center ">
                              <label className="gap-1 d-flex align-items-center custom-radio ">
    <input type="radio" name="pets" value={"1"} className="new-radio"     checked={pets === "1"}
        onChange={(e) => setPets("1")} />
    <span class="checkmark"></span>   {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_yes"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_yes"
                                  )[0]["value"] || "lbl_yes"
                                : "lbl_yes"
                              : "lbl_yes"}
  </label>

  <label className="gap-1 d-flex align-items-center custom-radio">
    <input type="radio" name="pets" value={"2"}  className="new-radio"    checked={pets ==="2"}
        onChange={(e) => setPets("2")}/>
    <span class="checkmark"></span>   {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_no"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_no"
                                  )[0]["value"] || "lbl_no"
                                : "lbl_no"
                              : "lbl_no"}
  </label>
  <label className="gap-1 d-flex align-items-center custom-radio">
    <input type="radio" name="pets" value={"3"}  className="new-radio"    checked={pets ==="3"}
        onChange={(e) => setPets("3")}/>
    <span class="checkmark"></span>   {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_agreement"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_agreement"
                                  )[0]["value"] || "lbl_agreement"
                                : "lbl_agreement"
                              : "lbl_agreement"}
  </label>


  </div>
                      
                            </Col>
                        
                                <Col lg="12" className="d-flex align-items-center">
                                                                        <Label className="renter-info-label width-class margin-negative lineheight-class fw-semibold">
                                                                          {frontLabelsName
                                                                            ? frontLabelsName.filter(
                                                                                (e) => e.key == "lbl_days_delivery"
                                                                              ).length > 0
                                                                              ? frontLabelsName.filter(
                                                                                  (e) => e.key == "lbl_days_delivery"
                                                                                )[0]["value"] || "lbl_days_delivery"
                                                                              : "lbl_days_delivery"
                                                                            : "lbl_days_delivery"}
                                                                        </Label>
                                                                
                                               <div style={{ position: "relative" }} className="width-100">
                                          <FaCalendarAlt
                                           className="date-styles"
                                          />
              
                                          <DatePicker
                                            selected={daysDelivery}
                                            onChange={(date) => setDaysDelivery(date)}
                                            dateFormat="dd/MM/yyyy"
                                            isClearable={daysDelivery ? true : false}
                                            placeholderText= {frontLabelsName
                                                                            ? frontLabelsName.filter(
                                                                                (e) => e.key == "lbl_days_delivery"
                                                                              ).length > 0
                                                                              ? frontLabelsName.filter(
                                                                                  (e) => e.key == "lbl_days_delivery"
                                                                                )[0]["value"] || "lbl_days_delivery"
                                                                              : "lbl_days_delivery"
                                                                            : "lbl_days_delivery"}
                                            className="date_style"
                                            minDate={new Date()}
                                          />
                              
                                        </div>
                                                                      </Col>
                              <Col lg="12" className="d-flex align-items-center">
                                                                        <Label className="renter-info-label  margin-negative  width-class lineheight-class fw-semibold">
                                                                        {frontLabelsName
                                                                ? frontLabelsName.filter(
                                                                    (e) => e.key == "lbl_length_rental"
                                                                  ).length > 0
                                                                  ? frontLabelsName.filter(
                                                                      (e) => e.key == "lbl_length_rental"
                                                                    )[0]["value"] || "lbl_length_rental"
                                                                  : "lbl_length_rental"
                                                                : "lbl_length_rental"}
                                                                        </Label>
                                                                        <div className="width-100 ">
                                                                   
                                                                
                                                                                                      <select
                                               className={`select_style set-bg-feild ${!years ? "has-placeholder" : ""}`}
                                              id="inputGroupSelect02"
                                              value={years}
                                              onChange={(e) => setYears(e.target.value)}
                                            >
                                              <option value="" disabled>
                                                {frontLabelsName?.find(e => e.key === "lbl_length_rental")?.value || "lbl_length_rental"}
                                         
                                              </option>
                                              {monthsArray?.length>0 && monthsArray.map((data, i) => (
                                  <option value={data} key={i}>
                                    {data}
                                  </option>
                                ))}
                                              {YearsArray &&
                                YearsArray.length > 0 &&
                                YearsArray.map((data, i) => (
                                  <option value={data } key={i}>
                                    {data} 
                                  </option>
                                ))}
                                            </select>
                                                   
                                              
                                                         
                                                            </div>
                                                                      </Col>
                                                                          {/* <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                              <Label className="renter-info-label  margin-negative width-class lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_minimum_size"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_minimum_size"
                                      )[0]["value"] || "lbl_minimum_size"
                                    : "lbl_minimum_size"
                                  : "lbl_minimum_size"} (m<sup>2</sup>)
                              </Label>
                              <Input
                                type="number"
                                placeholder=  {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_minimum_size"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_minimum_size"
                                      )[0]["value"] || "lbl_minimum_size"
                                    : "lbl_minimum_size"
                                  : "lbl_minimum_size"}
                                className="input_style"
                                value={size}
                                onChange={(e) =>
                                  setSize(e.target.value)
                                }
                              />
                            </Col> */}
                            <Col lg="12" className="renter-input-width1 d-flex align-items-center">
                              <Label className="renter-info-label width-class  margin-negative lineheight-class fw-semibold">
                                {frontLabelsName
                                  ? frontLabelsName.filter(
                                      (e) => e.key == "lbl_queries"
                                    ).length > 0
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_queries"
                                      )[0]["value"] || "lbl_queries"
                                    : "lbl_queries"
                                  : "lbl_queries"}
                              </Label>
                              <Input
                                type="textarea"
                                row="5"
                                placeholder={
                                 frontLabelsName
                                    ? frontLabelsName.filter(
                                        (e) => e.key == "lbl_queries"
                                      ).length > 0
                                      ? frontLabelsName.filter(
                                          (e) => e.key == "lbl_queries"
                                        )[0]["value"] || "lbl_queries"
                                      : "lbl_queries"
                                    : "lbl_queries"
                                }
                                className="input_style textareaxx"
                                value={queries}
                                onChange={(e) =>
                                  setQueries(e.target.value)
                                }
                              />
                            </Col>
                            {/* <Col lg="12" className="renter-input-width1  ">
                            <div className="d-flex align-items-center width-100class">
                              <Label className="renter-info-label width-class lineheight-class ">
                              {frontLabelsName
                      ? frontLabelsName.filter(
                          (e) => e.key == "lbl_length_rental"
                        ).length > 0
                        ? frontLabelsName.filter(
                            (e) => e.key == "lbl_length_rental"
                          )[0]["value"] || "lbl_length_rental"
                        : "lbl_length_rental"
                      : "lbl_length_rental"}
                              </Label>
                   
                    <Row className="row_style1 ">
                      <Col
                        lg="6"
                        md="6"
                        sm="6"
                        xs="12"
                        className="checkbox-styles1 ps-0"
                      >
                        <div className="field-group21 d-flex align-items-center">
                          <label htmlFor="16">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_short_term"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_short_term"
                                  )[0]["value"] || "lbl_short_term"
                                : "lbl_short_term"
                              : "lbl_short_term"}
                          </label>
                          <input
                            id="16"
                            type="checkbox"
                            value={shortTerm}
                            name="availableType"
                            onChange={() => {
                              if (shortTerm !== true) {
                                setLongTerm(false);
                                setShortTerm(true);
                              }
                            }}
                            checked={shortTerm === true}
                          />
                        </div>
                      </Col>
                      <Col
                        lg="6"
                        md="6"
                        sm="6"
                        xs="12"
                        className="checkbox-styles1 ps-0"
                      >
                  
                        <div className="field-group21  d-flex align-items-center">
                          <label htmlFor="17">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_long_term"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_long_term"
                                  )[0]["value"] || "lbl_long_term"
                                : "lbl_long_term"
                              : "lbl_long_term"}
                          </label>
                          <input
                            id="17"
                            type="checkbox"
                            value={longTerm}
                            name="availableType"
                            onChange={() => {
                              if (longTerm !== true) {
                                setLongTerm(true);
                                setShortTerm(false);
                              }
                            }}
                            checked={longTerm === true}
                          />
                        </div>
                      </Col>
               
                    </Row>
                    </div>
                    <Row className=" mt-2 ">
                      <div className="d-sm-flex d-column align-items-center">
                      {(shortTerm || longTerm) && (  <Label className="renter-info-label  width-class ">
                            {frontLabelsName
                              ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_from"
                                ).length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_from"
                                  )[0]["value"] || "lbl_from"
                                : "lbl_from"
                              : "lbl_from"}
                          </Label>)}
                          <div className="width-100-percent d-flex align-items-center">
                      {(shortTerm || longTerm) && (
                        <div className=" mt-1 d-flex align-items-center flex-grow-1">
                       
                          <div style={{ position: "relative" }} className="width-100-percent">
                            <FaCalendarAlt
                                className="date-stylexx"
                            />
                            <DatePicker
                              selected={availableFrom}
                              onChange={(date) => setAvailableFrom(date)}
                              dateFormat="dd/MM/yyyy"
                              isClearable={availableFrom ? true : false}
                              placeholderText="Available From"
                              className="date_style"
                              minDate={new Date()}
                            />
                            {fromDateError && (
                              <span className="invalid_span">
                                {fromDateError}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      {shortTerm === true && (
                        <div className=" mt-1 d-flex align-items-center flex-grow-1">
                          <Label className="renter-info-label d-flex justify-content-center width-30 mb-0">
                            {frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_to")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_to"
                                  )[0]["value"] || "lbl_to"
                                : "lbl_to"
                              : "lbl_to"}
                          </Label>
                          <div style={{ position: "relative" }} className="width-100-percent">
                            <FaCalendarAlt
                               className="date-stylexx"
                            />

                            <DatePicker
                              selected={availableTo}
                              onChange={(date) => setAvailableTo(date)}
                              dateFormat="dd/MM/yyyy"
                              isClearable={availableTo ? true : false}
                              placeholderText="Available To"
                              className="date_style"
                              minDate={new Date()}
                            />
                            {toDateError && (
                              <span className="invalid_span">
                                {toDateError}
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      </div>
                      </div>
                    </Row>
            
                            </Col> */}
                       
                      
                          </Row>
                        </FormGroup>
                      </div>
                      <div>
                        
                     
                      
                      </div>

                    
                    </div>

                    <div className="  d-flex justify-content-end pt-1">
           
                    
                        <div className=" button-tenant-profile">
                 
                          <Button
                           
                            onClick={handleAddTenantList}
                            disabled={disableSubmitButton}
                          >
                            {disableSubmitButton ? (
                        <CircularProgress
                          size={24}
                          sx={{
                            ":hover": { color: "#000" },

                            color: "#000",
                           
                          }}
                        />
                      ) :frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_update")
                                  .length > 0
                                ? frontLabelsName.filter(
                                    (e) => e.key == "lbl_update"
                                  )[0]["value"] || "lbl_update"
                                : "lbl_update"
                              : "lbl_update"}
                         
                          </Button>
                        </div>
               
                    </div>
                  </div>
                </Form>
              </div>
       
            </div>
          </div>
        </div>
      </div>
      <Suspense fallback={<Loading />}>
        <Footer />
      </Suspense>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => ({
  subscriptions: state.subscription,
  label: state.language,
});

export default connect(mapStateToProps, {
  addTenantList,
  getTenantList,

  getContentDetails,
})(Renters_list);
